module.exports = __webpack_public_path__ + "Austin Lai-203733d8.png";